import { render, staticRenderFns } from "./QueryPrice.vue?vue&type=template&id=0aa3a1c2"
import script from "./QueryPrice.vue?vue&type=script&lang=js"
export * from "./QueryPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports